import { memo, useMemo } from 'react'
import { useIntl } from 'react-intl'
import ExperiencesPageCarousel from './ExperiencesPageCarousel'
import useOrderExperienceCarousels from './useOrderExperienceCarousels'
import { take } from 'lib/array/arrayUtils'
import { useIntlDateFormatter, isSameMonth } from 'lib/datetime/dateUtils'
import { ISO_DATE_FORMAT, INTL_SHORT_MONTH } from 'constants/dateFormats'
import moment from 'moment'
import { formatPlacePhrase } from '@luxuryescapes/lib-location-grammar'

function getDateFormat(start: string, end: string, dateFormatter: ReturnType<typeof useIntlDateFormatter>) {
  const startDate = new Date(start)
  const endDate = new Date(end)
  let format = startDate.getDate().toString()
  if (!isSameMonth(startDate, endDate)) {
    format += ` ${dateFormatter(startDate, INTL_SHORT_MONTH)}`
  }
  format += ` - ${endDate.getDate()} ${dateFormatter(endDate, INTL_SHORT_MONTH)}`

  return format
}

function ExperiencesPageUpcomingOrderCarousels() {
  const intl = useIntl()
  const dateFormatter = useIntlDateFormatter()
  const carouselData = useOrderExperienceCarousels()
  const orderCarousels = useMemo(() => {
    return take(carouselData, 2)
  }, [carouselData])

  return <>
    {orderCarousels.map(carousel => <ExperiencesPageCarousel
      key={carousel.place.id}
      title={intl.formatMessage({
        id: 'abA3Vc2ABqwzn6pCeg_G',
        defaultMessage: 'Things to do when you’re in {placeName}',
        description: 'Carousel title for upcoming order experiences near a destination',
      }, { placeName: formatPlacePhrase({ location: { name: carousel.place.name }, language: intl.locale, intent: 'location' }) })}
      subtitle={intl.formatMessage({
        id: 'ayM9uEN3k_LIUyenaiMa',
        defaultMessage: '{dateRange} · Within 50km of {propertyName}',
        description: 'Carousel subtitle showing date range and proximity to booked property',
      }, {
        dateRange: getDateFormat(carousel.dates.checkIn, carousel.dates.checkOut, dateFormatter),
        propertyName: carousel.propertyName,
      })}
      place={carousel.place}
      latitude={carousel.coords.latitude}
      longitude={carousel.coords.longitude}
      checkIn={moment(carousel.dates.checkIn).subtract(7, 'days').format(ISO_DATE_FORMAT)}
      checkOut={moment(carousel.dates.checkOut).add(7, 'days').format(ISO_DATE_FORMAT)}
    />)}
  </>
}

export default memo(ExperiencesPageUpcomingOrderCarousels)
